<template>
  <b-card>
    <avito-area-form/>  
  </b-card>
</template>

<script>
import AvitoAreaForm from "@/components/AvitoAreaForm";

export default {
  name: "AvitoAreaAdd",
  components: {AvitoAreaForm}
}
</script>
